import { ImportedBookStub } from './types'
import { generateBuyLinks } from './utils'

export const mockImportedStubs: ImportedBookStub[] = [
  {
    id: 'stub-1',
    title: 'The Silent Echo',
    authorName: 'Elena Richards',
    isbn13: '9781234567890',
    asin: 'B08XYZ1234',
    format: 'paperback',
    coverUrl: 'https://images.unsplash.com/photo-1544947950-fa07a98d237f?w=200',
    completionPercent: 100,
    status: 'verified',
    buyLinks: generateBuyLinks({ isbn13: '9781234567890', asin: 'B08XYZ1234' }),
    missingFields: [],
  },
  {
    id: 'stub-2',
    title: 'Beyond the Veil',
    authorName: 'Marcus Chen',
    isbn13: '9780987654321',
    format: 'hardcover',
    coverUrl: 'https://images.unsplash.com/photo-1543002588-bfa74002ed7e?w=200',
    completionPercent: 85,
    status: 'enriched',
    buyLinks: generateBuyLinks({ isbn13: '9780987654321' }),
    missingFields: ['blurb', 'page_count'],
  },
  {
    id: 'stub-3',
    title: 'Whispers in the Dark',
    authorName: 'Sarah Johnson',
    asin: 'B09ABC5678',
    format: 'ebook',
    completionPercent: 45,
    status: 'stub',
    buyLinks: generateBuyLinks({ asin: 'B09ABC5678' }),
    missingFields: ['cover', 'blurb', 'publication_date', 'tags'],
  },
  {
    id: 'stub-4',
    title: 'The Memory Collector',
    authorName: 'Aiden Park',
    isbn13: '9781122334455',
    format: 'paperback',
    completionPercent: 60,
    status: 'stub',
    buyLinks: generateBuyLinks({ isbn13: '9781122334455' }),
    missingFields: ['cover', 'blurb', 'series_info'],
  },
  {
    id: 'stub-5',
    title: 'Fractured Realms',
    authorName: 'Zoe Chen',
    asin: 'B07DEF9012',
    format: 'audiobook',
    coverUrl:
      'https://images.unsplash.com/photo-1621351183012-e2f9972dd9bf?w=200',
    completionPercent: 90,
    status: 'enriched',
    buyLinks: generateBuyLinks({ asin: 'B07DEF9012' }),
    missingFields: ['narrator_name'],
  },
]
